import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, form, utils} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormBody, FormActions} = form;
import * as objednavkaActions from "../actions/objednavkaActions";
const {storeFromArea} = utils;
import * as ciselnikActions from "../actions/ciselnikActions";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Formulář pro tvorbu výdejních poboček společností.
 */
class SpolecnostPobockaVydejForm extends Component<WithTranslation> {

    static formName = 'SpolecnostPobockaVydejForm';

    render() {
        const {onClose, submitting, handleSubmit, pobockyNevydejniList, getPobockaName, t} = this.props;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ff.Autocomplete
                    useIdAsValue
                    label={t('private_dispensing_branch_single')}
                    name="pobockaId"
                    items={pobockyNevydejniList.rows}
                    getItemName={item => item ? getPobockaName(item) : ""}
                    renderItemContent={(item, name) => name}
                    required
                    disabled={submitting}
                />
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting} />
        </Form>
    }
}

function mapStateToProps(state) {
    return {
        pobockyNevydejniList: utils.storeFromArea(state, ciselnikActions.POBOCKY_NEVYDEJNI_LIST_AREA),
        objednavkaUzivatelPobockyList: storeFromArea(state, objednavkaActions.OBJEDNAVKA_UZIVATEL_POBOCKY_AREA),
    }
}

export default withTranslation()(connect(mapStateToProps)(reduxForm({
    form: SpolecnostPobockaVydejForm.formName,
})(SpolecnostPobockaVydejForm)));
